export default __webpack_public_path__ + "static/media/tablet_light.2681e8df.png";